import { Chip } from '@razz-team/ui-web';
import { getOptionLabel } from './utils';
import { useCallback } from 'react';

export function WebhookEventChip({
  event,
  onDelete,
}: {
  event: string;
  onDelete: (event: string) => void;
}) {
  const handleDelete = useCallback(() => {
    onDelete(event);
  }, [event, onDelete]);

  return (
    <Chip
      key={event}
      label={getOptionLabel(event)}
      color="primary"
      size="small"
      onDelete={handleDelete}
    />
  );
}
